import { render, staticRenderFns } from "./landTypes.vue?vue&type=template&id=c2fdc1aa"
import script from "./landTypes.vue?vue&type=script&lang=js"
export * from "./landTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports